import { z } from 'zod'
import { AttributionType } from '../constants/attribution'

export const referralSchema = z.object({
  id: z.string(),
  type: z.nativeEnum(AttributionType),
  date: z.date(),
})
